import React, { useState, useEffect, Fragment } from 'react';

import './other.css'

export default function Entry(props) {
    const [role, setRole] = useState('')

    useEffect(() => {
        if(props.location.search)
            setRole(props.location.search.replace('?role=',''))
        console.log('totot',props, props.location.search)
    }, [])
    return (
        <div className="center">
            <h2>Entrée bien enregistré</h2>
            <h3>Role : { role} </h3>

        </div>
    );
}